import { render, staticRenderFns } from "./content-link.vue?vue&type=template&id=68496fe1"
import script from "./content-link.vue?vue&type=script&lang=js"
export * from "./content-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports